module.exports = __webpack_public_path__ + "static/media/carousel-arrow-small-left.6f07ed7c.svg";